import { Loader2 } from 'lucide-react';

interface SpinnerProps {
  className?: string;
  /** Tamaño en px. Default 20. */
  size?: number;
}

export function Spinner({ className = '', size = 20 }: SpinnerProps) {
  return <Loader2 aria-label="Cargando" className={`animate-spin ${className}`} size={size} />;
}
